// @flow

import someModule from './someModule'

module.exports = { ...someModule }
